export const GET_LIST = 'getList'
export const SET_LIST = 'setList'
export const START = 'START'
export const SET_INSTANCE = 'SET_INSTANCE'
export const SET_SESSION = 'SET_SESSION'
export const DESTROY_SESSION = 'DESTROY_SESSION'
export const ADD_PARTICIPANT = 'ADD_PARTICIPANT'
export const REMOVE_PARTICIPANT = 'REMOVE_PARTICIPANT'
